import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import type { Country } from "@models";
import type { Observable } from "rxjs";
import type { LegacyResponse } from "./response.model";

@Injectable({ providedIn: "root" })
export class CommonService {
  private _usersApiUrl: string = environment.usersApiUrl;

  constructor(private _httpClient: HttpClient) {}

  public getCountries(): Observable<LegacyResponse<Country[]>> {
    return this._httpClient.get<LegacyResponse<Country[]>>(`${this._usersApiUrl}/countries`);
  }
}
